import { Box, Tooltip, Typography } from "@mui/material";
import { PlanFeatures as Features } from "../types";
import { Info } from "lucide-react";

export const PlanFeatures = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {Features.map((item) => {
        const Icon = item.icon;
        return (
          <Box
            sx={{ display: "flex", gap: "8px", alignItems: "center" }}
            key={item.feature}
          >
            <Icon size={24} color="#198282" />
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <Typography variant="body">{item.feature}</Typography>
              {item.feature === "Happiness guarantee" && (
                <Tooltip
                  placement={"top"}
                  enterTouchDelay={0}
                  leaveTouchDelay={5000}
                  title={
                    <Typography variant="body" sx={{ padding: "12px" }}>
                      If your Advisor isn't providing the mental load relief you
                      need, let us know and we'll find a better match.
                    </Typography>
                  }
                >
                  <Info size={16} color="#8E9598" />
                </Tooltip>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
